import * as Yup from 'yup';
import { nameRegex, passwordRegex } from 'src/config/regex';

export const enterEmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
});

export const signupValidationSchema = Yup.object().shape({
  userExists: Yup.boolean(),
  fullName: Yup.string()
    .required('Full Name is required')
    .min(2, 'Full Name must be at least 2 characters')
    .max(50, 'Full Name must be less then or equal to 50 characters')
    .matches(nameRegex, {
      message: 'Only letters are allowed',
    }),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required')
    .matches(passwordRegex, {
      message:
        'Weak password. Your password must contain at least one lowercase letter, one uppercase letter, one numeric digit, one special character, and be at least 8 characters long.',
    }),
  tempPassword: Yup.string().when('userExists', {
    is: true,
    then: Yup.string().required('Temporary Password is required'),
    otherwise: Yup.string(),
  }),
});
